<ion-content >
  
  <nav class="navbar sub-navigation with-overflow" id="top">
    <ul class="navbar-secondary">
        <li *ngFor="let cat of allCategories; index as i">
          <a id="aTag" (click)="switch_SportCategories(cat,$event)" class="sport-link-racing border-home" [ngClass]="{'active':cat.active}">
            <img src="{{cat.image}}" class="icon" id="imgTag" />
            <span innerHtml="{{cat.name}}"></span>
          </a>
        </li>
    </ul>
  </nav>

<app-next-ten-odds  [selectedBetCategory]="selectedBetCategory"></app-next-ten-odds>

</ion-content>